module.exports = __webpack_public_path__ + "static/media/IMG_2751-2.0802e12e.jpg";